import { Box } from '@mui/material';
import type { GeneratedAudio } from '../../../../types/generatedAudio';
import { AssetPreviewModal } from '../AssetPreviewModal';

interface GeneratedAudioPreviewModalProps {
  audio: GeneratedAudio | null;
  open: boolean;
  onClose: () => void;
}

const providerLabels: Record<string, string> = {
  elevenLabs: 'ElevenLabs',
  groq: 'Groq',
  playHt: 'PlayHT',
};

function GeneratedAudioPreviewModal({
  audio,
  open,
  onClose,
}: GeneratedAudioPreviewModalProps) {
  if (!open || !audio) return null;

  return (
    <AssetPreviewModal
      open
      onClose={onClose}
      name={audio.name}
      provider={audio.provider}
      providerLabels={providerLabels}
      model={audio.model}
      createdAt={audio.createdAt}
      assetUrl={audio.audioUrl}
      downloadFileName={audio.name || 'generated-audio'}
      maxWidth='sm'
      contentMinHeight='120px'
      renderContent={() => (
        <Box
          component='audio'
          controls
          src={audio.audioUrl}
          sx={{
            width: '100%',
            maxWidth: '460px',
            borderRadius: '8px',
          }}
        />
      )}
    />
  );
}

export { GeneratedAudioPreviewModal };
